module.exports = __webpack_public_path__ + "images/rich_heading/brand/watch/icon_937a2b37a1c54fd6b7cd8d6b10110407.png";